import { render, staticRenderFns } from "./CommentMemberCap.vue?vue&type=template&id=d5f32af0"
import script from "./CommentMemberCap.vue?vue&type=script&lang=js"
export * from "./CommentMemberCap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_ejs@3.1.10_vue-template-compiler@2.6.14_webpack@5.93.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports